import { Form, FormItemProps, Radio, RadioProps } from 'antd';

interface RadioFormProps {
  formProps?: FormItemProps;
  radioProps?: RadioProps;
  options: {
    disabled?: boolean;
    label?: string;
    value: string | number | boolean;
  }[];
}

export const RadioForm = ({
  formProps,
  radioProps,
  options,
}: RadioFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    <Radio.Group {...radioProps}>
      {options.map(
        (option: {
          disabled?: boolean;
          label?: string;
          value: string | number | boolean;
        }) => (
          <Radio
            disabled={option.disabled}
            value={option.value}
            key={`${option.value}-${option.label}`}
          >
            {option.label}
          </Radio>
        )
      )}
    </Radio.Group>
  </Form.Item>
);
